import { entityReducer } from 'modules/entities';

export default entityReducer;
